import Navbar from './Navbar';
import Bannier from './Bannier';

function Header() {
    return(
        <>
            <Navbar />
            <Bannier />
        </>
    )
}

export default Header;